import { push } from 'react-router-redux';
import { clearModalUpFront } from 'actions';

export const OPEN_FORM_CHOICE_MODAL = 'OPEN_FORM_CHOICE_MODAL';
export const CLOSE_FORM_CHOICE_MODAL = 'CLOSE_FORM_CHOICE_MODAL';

function openFormChoiceModal(formType) {
  return {
    type: OPEN_FORM_CHOICE_MODAL,
    formType,
    isFormChoiceShown: true
  };
}

function closeFormChoiceModal() {
  return {
    type: CLOSE_FORM_CHOICE_MODAL,
    isFormChoiceShown: false
  };
}

export function showFormChoiceModal(formType) {
  return (dispatch) => {
    dispatch(openFormChoiceModal(formType));
    return dispatch(push('/form-selection'));
  };
}

export function hideFormChoiceModal() {
  return (dispatch) => {
    dispatch(clearModalUpFront());
    dispatch(closeFormChoiceModal());
    return dispatch(push('/form-selection'));
  };
}
